import React from 'react';
import { CheckCircle, Clock } from 'lucide-react';
import { Modal } from './Modal';
import { Button } from './Button';

interface DeletionSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const DeletionSuccessModal: React.FC<DeletionSuccessModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={() => {}} title="">
      <div className="flex flex-col items-center text-center space-y-5 py-2">
        <div className="relative">
          <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center">
            <CheckCircle className="h-10 w-10 text-green-600" />
          </div>
        </div>

        <div className="space-y-2">
          <h2 className="text-xl font-semibold text-gray-900">Deletion Request Submitted</h2>
          <p className="text-gray-600 text-sm leading-relaxed max-w-sm">
            Your account deletion request has been successfully sent to our admin team and is awaiting approval.
          </p>
        </div>

        <div className="w-full p-4 bg-amber-50 border border-amber-200 rounded-lg flex items-start gap-3 text-left">
          <Clock className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-amber-900">What happens next?</p>
            <p className="text-sm text-amber-800 mt-1">
              Your account will remain active until an admin reviews and approves your request. You will be notified once the deletion is processed.
            </p>
          </div>
        </div>

        <Button
          variant="primary"
          onClick={onClose}
          className="w-full"
        >
          OK, Got It
        </Button>
      </div>
    </Modal>
  );
};
